import { ApiService } from "./api.service";
import { PrimeIcons } from "@primevue/core/api";
import moment from "moment";
import { AppIcons } from "../constants/app-icons";
import { Core } from "../helpers/core";
import { Money } from "../helpers/money";
import { DOMAIN } from "./domain-constant";
export default class CreditMemoService extends ApiService {
  namespace = "credit-memo";
  previewNamespace = "invoice";
  template = "defaultTemplate";
  fullWindow = false;
  listingRelations = "customerName";
  relations =
    "?expand=lineItems,layout,writeoffs,overPayments,headers,footers,messages,journals,overPayments,files,files.file,files.file.commentsCount,customerName,salesRep";
  icon = "Check";
  // icon = "Invoice";
  DOMAIN = DOMAIN.CREDIT_MEMO;
  data = [];
  favicon = "Invoice";
  enableSchedular = true;
  showLeftBar = false;
  useNextNumber = true;
  name = this.terminology.creditMemo.plural;
  singular = this.terminology.creditMemo.singular;
  plural = this.terminology.creditMemo.plural;
  vowel = this.terminology.creditMemo.vowel;
  labelKey = "number";
  layout = 1;
  Width = 1300;
  gemItems = [
    {
      key: "listing",
      label: "All Credit Memos",
      icon: AppIcons.BULLETS,
    },
    {
      key: "create",
      label: "Add a Credit Memo",
      icon: AppIcons.PLUS,
    },

    {
      key: "create",
      label: "Settings",
      services: DOMAIN.INVOICE_SETTING,
      icon: AppIcons.GEAR,
    },
    // {
    //   key: "create",
    //   label: "Add a Sales Reciept",
    //   services: 117,
    //   icon: PrimeIcons.LIST,
    // },
    // {
    //   key: "create",
    //   label: "Add an Estimate",
    //   services: 40,
    //   icon: PrimeIcons.LIST,
    // },
  ];
  columns = [
    {
      header: this.t("number"),
      icon: AppIcons.SHRED,
      field: "number",
      width: "5",
      sortable: true,
    },
    {
      header: this.t("customer"),
      icon: AppIcons.USER_SILHOUETTE,
      field: "customer",
      template: (data) =>
        data.customer?.display_name ?? data.customerName ?? "",
    },
    {
      header: this.t("date"),
      icon: AppIcons.GREEN_CALENDAR,
      field: "date",
      width: "5",
      sortable: true,
      template: (data) => {
        return Core.datey(data.date);
      },
    },

    {
      header: this.t("amount"),
      icon: AppIcons.MONEY,
      field: "amount",
      width: "5",
      sortable: true,
      template: (data) => Money.format(data.total_amount)
    },
    {
      header: this.t("balance"),
      icon: AppIcons.MONEY,
      field: "balance_due",
      width: "3",
      sortable: true,
      template: (data) => {
        let balance_due = 0;
        return Money.format(data.balance_due || balance_due);
      },
    },
    {
      header: this.t("status"),
      icon: AppIcons.LIGHTNING,
      field: "status",
      width: "5",
      statusIndicator: true,
    },
    {
      header: "",
      icon: AppIcons.PEN,
      tooltip: "Write Offs",
      width: "3",
    },
  ];
  lineItems = [
    {
      key: "edit",
      label: "Apply Subtotal",
      icon: PrimeIcons.PENCIL,
    },
    {
      key: "announce",
      label: "Bank Line",

      icon: PrimeIcons.LIST,
    },
    {
      key: "email",
      label: "Discount",
      icon: PrimeIcons.ENVELOPE,
    },
    {
      key: "bookmark",
      label: "Good",
      icon: PrimeIcons.BOOKMARK,
    },
    {
      key: "bookmark",
      label: "Inventory Item",
      icon: PrimeIcons.BOOKMARK,
    },
    {
      key: "bookmark",
      label: "Other Change",
      icon: PrimeIcons.BOOKMARK,
    },
    {
      key: "bookmark",
      label: "Over Payment",
      icon: PrimeIcons.BOOKMARK,
    },
    {
      key: "bookmark",
      label: "Service",
      icon: PrimeIcons.BOOKMARK,
    },
    {
      key: "bookmark",
      label: "Tax",
      icon: PrimeIcons.BOOKMARK,
    },
    {
      separator: true,
    },
    {
      key: "inactive",
      label: "Time & Expenses",
      icon: PrimeIcons.LOCK,
    },
  ];
  moreItems = [
    {
      key: "create",
      label: "Load template",
      icon: AppIcons.FOLDER,
      type: "1",
    },
    {
      key: "create",
      label: "Save and preview",
      icon: AppIcons.PREVIEW,
      type: "2",
    },
    {
      key: "create",
      label: "Save and print",
      icon: AppIcons.PRINTER,
      type: "3",
    },
    {
      key: "create",
      label: "Save and e-mail",
      icon: AppIcons.MAIL,
      type: "4",
    },
    {
      key: "create",
      label: "Manage layout",
      icon: AppIcons.LAYOUT,
      type: "5",
    },
  ];
  navItems = [
    {
      key: "listing",
      label: this.t("viewAllEntities", { entity: this.plural }),
      icon: AppIcons.BULLETS,
    },
    {
      key: "bookmark",
      label: this.t("viewMyBookmarks", { entity: this.singular }),
      icon: AppIcons.BOOKMARK,
    },
    {
      key: "inactive",
      label: this.t("viewInactiveEntity", { entity: this.plural }),
      services: DOMAIN.VENDOR,
      icon: AppIcons.DISABLE,
    },
  ];
  getActionMenu(item) {
    const entity = this.singular;
    return [
      {
        key: "detail",
        label: this.t("previewThisEntity", { entity }),
        icon: AppIcons.EYE,
      },
      {
        key: "edit",
        label: this.t("editThisEntity", { entity }),
        icon: AppIcons.EDIT,
      },
      {
        key: "announce",
        label: this.t("announceThisEntity", { entity }),
        services: DOMAIN.MESSAGES,
        icon: AppIcons.ANNOUNCEMENT,
      },
      {
        key: "email",
        label: this.t("emailThisEntity", { entity }),
        icon: AppIcons.MAIL,
        services: DOMAIN.EMAIL,
      },
      {
        key: "bookmark",
        label: this.t("bookmarkThisEntity", { entity }),
        icon: AppIcons.BOOKMARK,
      },
    ];
  }
  listMenuItems = [
    {
      key: "edit",
      label: this.t("editThisEntity", { entity: this.singular }),
      icon: AppIcons.EDIT,
    },
    {
      key: "announce",
      label: this.t("announceThisEntity", { entity: this.singular }),
      services: DOMAIN.MESSAGES,
      icon: AppIcons.ANNOUNCEMENT,
    },
    {
      key: "email",
      label: this.t("emailThisEntity", { entity: this.singular }),
      icon: AppIcons.MAIL,
    },
    {
      key: "bookmark",
      label: this.t("bookmarkThisEntity", { entity: this.singular }),
      icon: AppIcons.BOOKMARK,
    },
    {
      key: "create",
      label: this.t("copyThisEntity", { entity: this.singular }),
      icon: AppIcons.COPY,
      serviceId: DOMAIN.COPY_PAYABLES,
    },
    {
      key: "exec",
      label: this.t("printThisEntity", { entity: this.singular }),
      icon: AppIcons.PRINTER,
      action: (item, ctx) => {
        ctx.$emit("print", item);
      },
    },
    {
      key: "transaction",
      label: this.t("transactionSummary"),
      icon: AppIcons.DOLLAR,
    },
    {
      key: "viewJournal",
      label: this.t("viewJournal"),
      icon: AppIcons.JOURNAL_VIEW,
    },
  ];
  permissions = [
    {
      key: "credit_memo",
      display_name: "Credit Memo",
      icon: AppIcons.DOCUMENT_WITH_TEXT,
      value: 1,
    },
    {
      key: "over_payment",
      display_name: "Over Payment",
      icon: AppIcons.CREDIT_CARD_GREEN,
      value: 1,
    },
    {
      key: "is_template",
      display_name: "Template",
      icon: AppIcons.TEMPLATE,
      value: 1,
    },
    {
      key: "is_draft",
      display_name: "Draft",
      icon: AppIcons.DOCUMENT_WITH_TEXT,
      value: 1,
    },
    {
      key: "open",
      display_name: "Open",
      icon: AppIcons.NOTEBOOK,
      value: 1,
    },
    {
      key: "status",
      display_name: "Completed",
      icon: AppIcons.MONEY,
      value: 1,
    },
    {
      key: "is_in_print_que",
      display_name: "Print Que",
      icon: AppIcons.FAX,
      value: 1,
    },
    {
      key: "is_in_email_que",
      display_name: "Email Que",
      icon: AppIcons.MAIL,
      value: 1,
    },
    
  ];
  filterItems = [
    { name: "Status", key: "status", value: "2", realm: "2" },
    { name: "Date", key: "date", value: "3", realm: "1" },
    { name: "Due Date", key: "due", value: "4", realm: "0" },
  ];
  gemMenuItems = [
    {
      key: "create",
      label: "Adding a Credit Memo",
      icon: AppIcons.LIST,
    },
  ];

  constructor() {
    super("credit-memos");
  }
}
